import { useTranslation } from "react-i18next";

export type Lang = "ko" | "en";

// 데이터 파일(src/data/*)처럼 긴 본문을 ko/en 객체로 함께 두는 경우 현재 언어를 고르는 데 사용합니다.
export function useLang(): Lang {
  const { i18n } = useTranslation();
  return i18n.language?.startsWith("en") ? "en" : "ko";
}
